import { Theme, TypographyPropsVariantOverrides } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { TypographyOptions, Variant } from '@mui/material/styles/createTypography'
import { OverridableStringUnion } from '@mui/types'
import { Geist_Mono, Inter } from 'next/font/google'
import { palette } from './palette'

const inter = Inter({
    subsets: ['latin'],
    display: 'swap',
})

export const monoFont = Geist_Mono({
    subsets: ['latin'],
    display: 'swap',
})

declare module '@mui/material/styles' {
    interface TypographyVariants {
        disabled: React.CSSProperties;
        unconfigured: React.CSSProperties;
        eyebrow: React.CSSProperties;
        monospace: React.CSSProperties;
    }

    interface TypographyVariantsOptions {
        disabled?: React.CSSProperties;
        unconfigured?: React.CSSProperties;
        eyebrow?: React.CSSProperties;
        monospace?: React.CSSProperties;
    }
}

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        disabled: true;
        unconfigured: true;
        eyebrow: true;
        monospace: true;
    }
}

export type TypogaphyVariantType = OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>

export const C1TypographyVariants = {
    fontFamily: inter.style.fontFamily,
    h1: {
        fontWeight: 500,
        fontSize: 36,
    },
    h2: {
        fontWeight: 500,
        fontSize: 28,
    },
    h3: {
        fontWeight: 500,
        fontSize: 22,
    },
    h4: {
        fontWeight: 500,
        fontSize: 18,
    },
    h5: {
        fontWeight: 500,
        fontSize: 16,
    },
    h6: {
        fontWeight: 500,
        fontSize: 14,
    },
    subtitle1: {
        fontWeight: 500,
        fontSize: 12,
        textTransform: 'none',
    },
    subtitle2: {
        fontWeight: 500,
        fontSize: 10,
        textTransform: 'none',
    },
    body1: {
        fontWeight: 450,
        fontSize: 14,
        lineHeight: 1.3,
    },
    body2: {
        fontWeight: 450,
        // TODO: Links, TableCell, MenuItem, Breadcrumb, ListItemText, Tooltip and some form components use body2.
        // Keep the same as body1 for now. We have figure this out in design first.
        fontSize: 14,
        lineHeight: 1.3,
    },
    caption: {
        fontWeight: 450,
        fontSize: 12,
        color: palette.text.primary,
    },
    eyebrow: {
        fontWeight: 450,
        fontSize: 13,
        color: palette.text.secondary,
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
    },
    disabled: {
        fontWeight: 450,
        fontSize: 14,
        lineHeight: 1.3,
        opacity: 0.7, // 70% will pass WCAG AA contrast (assuming default body text color & #FFF bg)
        color: 'inherit',
        fontStyle: 'italic',
    },
    unconfigured: {
        fontWeight: 450,
        fontSize: 14,
        lineHeight: 1.3,
        color: 'inherit',
        opacity: 0.7, // 70% will pass WCAG AA contrast (assuming default body text color & #FFF bg)
        fontStyle: 'italic',
    },
    monospace: {
        fontFamily: monoFont.style.fontFamily,
        fontWeight: 500,
    },
} satisfies TypographyOptions

export const C1TypographyTheme: Components<Theme>['MuiTypography'] = {
    styleOverrides: {
        root: ({ theme }) => theme.unstable_sx({
            '& .MuiSvgIcon-root': {
                display: 'inline-block',
                verticalAlign: 'middle',
            },
        }),
    },
}
